import React from 'react'
import Card from 'react-bootstrap/Card'
import FileNameDropdown from './FileNameDropdown'
import SignalPanel from '../../scoring2/components/SignalPanel';
function ListItem(props) {
	//console.log(props)
	return <>
		<Card style={{
			width: '40rem',
			marginLeft: 'auto',
			marginRight: 'auto'
		}}>
			<Card.Body>
				<FileNameDropdown totalNumber={props.totalNumber} fileName={props.fileName} selectItem={props.selectItem} paused={props.paused} />
				{
					props.totalNumber !== 0 ?
						<a href={'/download?id=' + props.psgFileId} style={{ float: 'right' }}>下載</a> :

						// 作答期間關閉下載功能
						// <a href={'/download?id=' + props.psgFileId} style={{ float: 'right' }}></a> :
						null
				}
			</Card.Body>
		</Card>
		<br />
	</>
}

export default ListItem